import React, { useContext, useEffect, useState } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import BackEndAPI from '../../../Services/BackEndAPI'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import { DeterminacaoInterface } from '../../../ImportBackend/Interfaces/DeterminacaoInterfaces'
import ModalComponent from '../../../DevComponents/ModalComponent'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import { GridCloseIcon } from '@mui/x-data-grid'
import LeituraCalculoComponent from '../Leituras/LeituraCalculoComponent'
import Condicional from '../../../Layout/Condicional'
import ClsCalcularResultado from '../Leituras/ClsCalcularResultado'
import { LeituraInterface } from '../../../ImportBackend/Interfaces/LeituraInterfaces'
import { UnidadeDeterminacaoInterface } from '../../../ImportBackend/Interfaces/UnidadeDeterminacaoInterfaces'
import { UnidadeDeterminacaoTipoInformacaoType } from '../../../ImportBackend/types/ConstantesDataTypes'
import { AmostraReferenciaLeituraInterface } from '../../../ImportBackend/Interfaces/AmostraReferenciaInterface'
import InputText from '../../../DevComponents/InputText'
import CheckIcon from '@mui/icons-material/Check'
import { clsUtils } from 'zlib-utils'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'

interface PropsInterface {
	idMaterial: number
	idAmostraReferencia: number
}

export default function AmostraReferenciaDeterminacoes({ idMaterial, idAmostraReferencia }: PropsInterface) {

	const clsCalcularResultado: ClsCalcularResultado = new ClsCalcularResultado()

	const ResetDados: DeterminacaoInterface = {
		idDeterminacao: 0,
		nome: '',
		metodologia: '',
		idEquipamento: 0,
		ordemImpressaoMapaLeitura: '',
		simbolo: '',
		calculo: [
		],
		parametros: [
		],
		cabecalhoLaudo: '',
		idMaterial: 0,
		idTipoMapaProducao: 0,
		chave: '',
		ordem: 0,
		leituraPadraoPorBandeja: false,
		padraoAleatorioPorBandeja: false,
		novaPaginaLaudo: false,
		idUnidadeDeterminacao: 0,
		laboratorio: false,
		laudo: false,
		permitirValorSemFormula: false
	}

	// Contém a Determinação selecionada para edição da leitura / entrada de dados
	const [rsDeterminacaoSelecionada, setRsDeterminacaoSelecionada] = useState<DeterminacaoInterface>(ResetDados)

	// Unidade de Determinação - Contém a undiade da determinação selecionada para edição da leitura / entrada de dados 
	const [rsUnidadeDeterminacao, setRsUnidadeDeterminacao] = useState<UnidadeDeterminacaoInterface>({
		casasDecimais: 0,
		idUnidadeDeterminacao: 0,
		conversoes: [],
		descricaoLaudo: '',
		tipoInformacao: UnidadeDeterminacaoTipoInformacaoType.TEXTO,
		unidade: ''
	})

	// const [rsLeiturasRealizadasAmostraReferencia, setRsLeiturasRealizadasAmostraReferencia] = useState<Array<AmostraReferenciaLeituraInterface>>([])

	const [rsAmostraReferenciaLeitura, setRsAmostraReferenciaLeitura] = useState<AmostraReferenciaLeituraInterface>({
		dataHoraLeitura: '',
		idAmostraReferencia: 0,
		idDeterminacao: 0,
		idUnidadeDeterminacao: 0,
		idUsuario: 0,
		leitura: {},
		resultado: '',
		unidadeResultado: ''
	})

	const [exibirLeituraAmostraReferencia, setExibirLeituraAmostraReferencia] = useState<boolean>(false)

	const [rsDeterminacoes, setRsDeterminacoes] = useState<Array<DeterminacaoInterface & { ultimaLeitura: string } & { leituras: Array<AmostraReferenciaLeituraInterface> }>>([])

	const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

	const clsApi: BackEndAPI = new BackEndAPI()

	/*
	const pesquisarUltimaLeitura = (rsDeterminacao: DeterminacaoInterface): string => {

		let retorno: string = ''

		// console.log(rsDeterminacao, rsLeiturasRealizadasAmostraReferencia.length)

		if (rsDeterminacao && rsLeiturasRealizadasAmostraReferencia) {

			const leituraRealizada = rsLeiturasRealizadasAmostraReferencia.find((leitura) => leitura.idDeterminacao === rsDeterminacao.idDeterminacao)

			if (leituraRealizada) {
				retorno = leituraRealizada.resultado + ' ' + leituraRealizada.unidadeResultado
			}

		}

		return retorno

	}
		*/

	const Cabecalho: Array<DataTableCabecalhoInterface> = [
		{
			campo: 'nome',
			cabecalho: 'Nome',
			alinhamento: 'left'
		},
		{
			campo: 'simbolo',
			cabecalho: 'Símbolo',
			alinhamento: 'left'
		},
		{
			campo: 'ultimaLeitura',
			cabecalho: 'Última Leitura',
			alinhamento: 'left'
		}
	]

	const CabecalhoGrupo: Array<DataTableCabecalhoInterface> = [
		{
			campo: 'leitura',
			cabecalho: 'Leitura',
			alinhamento: 'left'
		},
		{
			campo: 'resultado',
			cabecalho: 'Resultado',
			alinhamento: 'left'
		},
		{
			campo: 'unidadeResultado',
			cabecalho: 'Unidade Resultado',
			alinhamento: 'left'
		}
	]

	const pesquisarDeterminacoes = () => {

		if (idMaterial > 0) {
			const query = `
				getAmostrasReferenciaDeterminacoes(idMaterial: ${idMaterial}) {
					idDeterminacao
					nome
					metodologia
					simbolo
					calculo {
						descricao
						tipoInformacao
						conteudo
						variavel
					}
					parametros {
						descricao
						tipoInformacao
						conteudo
						variavel
					}
					cabecalhoLaudo
					idMaterial
					idTipoMapaProducao
					chave
					ordem
					leituraPadraoPorBandeja
					padraoAleatorioPorBandeja
					novaPaginaLaudo
					idUnidadeDeterminacao
					laboratorio
					laudo
					permitirValorSemFormula
				}
			`

			clsApi.query<Array<DeterminacaoInterface>>(
				query,
				'getAmostrasReferenciaDeterminacoes',
				'Pesquisando Determinações...',
				contexto
			).then((rsDeterminacoesEncontradas: any) => {

				const query = `
					getAmostrasReferenciaLeitura(idAmostraReferencia: ${idAmostraReferencia}) {
						idAmostraReferencia
						dataHoraLeitura
						idUsuario
						idDeterminacao
						idUnidadeDeterminacao
						resultado
						unidadeResultado
						leitura
					}
				`

				clsApi.query<Array<AmostraReferenciaLeituraInterface>>(
					query,
					'getAmostrasReferenciaLeitura',
					'Pesquisando Leituras Realizadas...',
					contexto
				).then(rsLeiturasRealizadas => {

					rsDeterminacoesEncontradas.forEach((determinacao: any, indice: number) => {
						const leiturasRealizada = rsLeiturasRealizadas.filter((leitura) => leitura.idDeterminacao === determinacao.idDeterminacao)

						if (leiturasRealizada.length > 0) {
							rsDeterminacoesEncontradas[indice].ultimaLeitura = leiturasRealizada[0].resultado + ' ' + leiturasRealizada[0].unidadeResultado
							rsDeterminacoesEncontradas[indice].leituras = leiturasRealizada
						} else {
							rsDeterminacoesEncontradas[indice].ultimaLeitura = ''
							rsDeterminacoesEncontradas[indice].leituras = []
						}
					})

					// setRsLeiturasRealizadasAmostraReferencia(rsLeiturasRealizadas)
					setRsDeterminacoes(rsDeterminacoesEncontradas)

				})

			})
		} else {
			setRsDeterminacoes([])
			// setRsLeiturasRealizadasAmostraReferencia([])
		}

	}

	useEffect(() => {
		pesquisarDeterminacoes()
		//eslint-disable-next-line
	}, [idMaterial])

	const btEditarLeituraAmostraReferencia = (rsDeterminacao: DeterminacaoInterface) => {
		setRsDeterminacaoSelecionada(rsDeterminacao)
		pesquisaUnidadeDeterminacao(rsDeterminacao.idUnidadeDeterminacao)
		setExibirLeituraAmostraReferencia(true)
	}

	const pesquisaUnidadeDeterminacao = (idUnidadeDeterminacao: number): Promise<boolean> => {

		const query: string = `
			getUnidadeDeterminacaoPorId (idUnidadeDeterminacao: ${idUnidadeDeterminacao}) {
			idUnidadeDeterminacao
			unidade
			casasDecimais
			tipoInformacao
			conversoes {
				unidade
				calculo
				casasDecimais
				tipoInformacao
				posCalculo
			}
			}
		`

		return clsApi.query<UnidadeDeterminacaoInterface>(query, 'getUnidadeDeterminacaoPorId', 'Carregando Unidade da Determinação...', contexto).then(rsUnidadeDeterminacao => {
			setRsUnidadeDeterminacao(rsUnidadeDeterminacao)
			// rsUnidadeDeterminacaoInicial.current = rsUnidadeDeterminacao.unidade
			return true
		})

	}

	const onAlterarLeitura = (propriedade: string, novoValor: number | string | boolean, encerrarEdicao: boolean) => {

		let leitura: LeituraInterface = {
			idAmostra: 0,
			idDeterminacao: rsDeterminacaoSelecionada.idDeterminacao as number,
			idUnidadeDeterminacao: rsDeterminacaoSelecionada.idUnidadeDeterminacao,
			unidadeResultado: '',
			resultado: '',
			digitacao: { [propriedade]: novoValor }
		}

		setRsAmostraReferenciaLeitura(calcularResultadoAmostra(leitura))

	}

	const calcularResultadoAmostra = (rsDeterminacaoLeitura: LeituraInterface): AmostraReferenciaLeituraInterface => {

		let retorno: AmostraReferenciaLeituraInterface = {
			idAmostraReferencia: idAmostraReferencia,
			dataHoraLeitura: new Date().toISOString(),
			idUsuario: contexto.loginState.idUsuario,
			idDeterminacao: rsDeterminacaoLeitura.idDeterminacao,
			leitura: {},
			idUnidadeDeterminacao: rsDeterminacaoLeitura.idUnidadeDeterminacao,
			unidadeResultado: rsDeterminacaoLeitura.unidadeResultado,
			resultado: rsDeterminacaoLeitura.resultado
		}

		// Realiza o Cálculo do Resultado
		let { digitacao, calculoExecutadoComSucesso } = clsCalcularResultado.calcular(
			rsDeterminacaoLeitura.digitacao,
			{},
			rsDeterminacaoSelecionada,
			rsUnidadeDeterminacao
		)

		retorno.leitura = { ...digitacao }
		retorno.resultado = digitacao.RESULTADO ? String(digitacao.RESULTADO) : ''

		if (calculoExecutadoComSucesso) {

			rsDeterminacaoLeitura.digitacao = digitacao

			//Conversão para Unidade
			const { resultado, unidadeResultado, conversaoRealizadaComSucesso } = clsCalcularResultado.converterResultadoUnidade(
				rsDeterminacaoLeitura,
				rsUnidadeDeterminacao
			)

			if (conversaoRealizadaComSucesso) {
				retorno.resultado = resultado
				retorno.unidadeResultado = unidadeResultado
			} else {
				calculoExecutadoComSucesso = false
			}

		}

		return retorno

	}

	const onCancelarLeituraAmostraReferencia = () => {
		setExibirLeituraAmostraReferencia(false)
		setRsDeterminacaoSelecionada(ResetDados)
	}

	const onGravarLeituraAmostraReferencia = () => {

		let tmpDados: any = { ...rsAmostraReferenciaLeitura }

		tmpDados.leitura = JSON.stringify(rsAmostraReferenciaLeitura.leitura)

		const mutation: string = `
			updateAmostraReferenciaLeitura (dados: ${clsUtils.ConverterEmGql(tmpDados)}) {
				ok
				mensagem
			}
		`

		return clsApi.mutation<RespostaPadraoInterface>(mutation, 'updateAmostraReferenciaLeitura', 'Gravando Dados de Leitura da Amostra Referência...', contexto).then(rs => {

			if (rs.ok) {
				pesquisarDeterminacoes()
				onCancelarLeituraAmostraReferencia()
			} else {

				contexto.setMensagemState({
					cb: null,
					exibir: true,
					mensagem: rs.mensagem,
					titulo: 'Erro ao Gravar Leitura da Amostra Referência',
					exibirBotao: true,
					tipo: MensagemTipo.Error
				})

			}
		})


	}

	return (
		<>
			<ModalComponent
				exibir={exibirLeituraAmostraReferencia}
				setExibir={setExibirLeituraAmostraReferencia}
			>
				<Grid container sx={{ p: 4 }}>

					<Condicional condicao={rsDeterminacaoSelecionada !== null && rsDeterminacaoSelecionada !== undefined && rsDeterminacaoSelecionada.calculo !== undefined && rsDeterminacaoSelecionada.calculo.length > 0}>

						<Grid item xs={12}>
							<Typography variant='h6'>{rsDeterminacaoSelecionada.nome}</Typography>
						</Grid>

						{
							rsDeterminacaoSelecionada.calculo.map((calculo, indiceCalculo) => (
								<>

									<Condicional key={indiceCalculo} condicao={calculo.tipoInformacao === 'ENTRADA'}>

										<Grid item xs={12} key={indiceCalculo}>
											<LeituraCalculoComponent
												exibirLabel={true}
												calculo={calculo}
												onAlterar={(propriedade: string, novoValor: number | string | boolean, encerrarEdicao: boolean) => { onAlterarLeitura(propriedade, novoValor, encerrarEdicao) }}
												value={''}
											/>
										</Grid>

									</Condicional>

									<Condicional key={indiceCalculo} condicao={calculo.tipoInformacao !== 'ENTRADA'}>

										<InputText

											dados={rsAmostraReferenciaLeitura}
											field='resultado'
											label='Resultado'
											disabled={true}

										/>

										{rsUnidadeDeterminacao.unidade}

									</Condicional>

								</>
							))
						}
					</Condicional>

					<Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button variant='contained' startIcon={<CheckIcon />} sx={{ mt: 2 }} onClick={() => onGravarLeituraAmostraReferencia()}>Gravar</Button>
						<Button variant='contained' startIcon={<GridCloseIcon />} sx={{ mt: 2, ml: 2 }} onClick={() => onCancelarLeituraAmostraReferencia()}>Cancelar</Button>
					</Grid>
				</Grid>

				<ExibirJSONDev oque={['rsAmostraReferenciaLeitura', rsAmostraReferenciaLeitura]} />
				<ExibirJSONDev oque={['rsDeterminacaoSelecionada', rsDeterminacaoSelecionada]} />
				<ExibirJSONDev oque={['rsUnidadeDeterminacao', rsUnidadeDeterminacao]} />
			</ModalComponent>


			<Grid container>
				<Grid item xs={12} sx={{ mb: 1 }}>
					<Typography variant="h6">Determinações</Typography>
				</Grid>
				<Grid item xs={12}>
					<DataTable dados={rsDeterminacoes}
						cabecalho={Cabecalho}
						cabecalhoGrupo={CabecalhoGrupo}
						campoGrupo='leituras'
						acoes={[
							{ icone: 'create', toolTip: 'Alterar', onAcionador: (rsDeterminacao: DeterminacaoInterface) => btEditarLeituraAmostraReferencia(rsDeterminacao) }
						]} />
				</Grid>
			</Grid>

			<ExibirJSONDev exibir={false} oque={['rsDeterminacaoSelecionada', rsDeterminacaoSelecionada]} />
		</>
	)
}
